import { useLoading } from "../context/LoadingContext";

import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useRotinas } from "../context/RotinasContext";
import { useUser } from "../context/UserContext";
import { FaCalendarAlt, FaSave } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from "date-fns/locale/pt-BR";
import "../css/RotinasFuncionario.css";
import ChecklistRotina from "../components/ChecklistRotina";
import SelectBoxResponsavelPesquisa from "./SelectBoxResponsavelPesquisa";
import SelectBoxResponsavelCadastro from "./SelectBoxResponsavelCadastro";
import { useLocation, useNavigate } from "react-router-dom";
import AsyncCreatableSelect from "react-select/async-creatable";
import BackButton from "../components/BackButton";

const DiasSemanaCheckbox = ({ diasSelecionados, onChange }) => {
  const dias = [
    { id: "segunda", label: "Segunda-Feira" },
    { id: "terca", label: "Terça-Feira" },
    { id: "quarta", label: "Quarta-Feira" },
    { id: "quinta", label: "Quinta-Feira" },
    { id: "sexta", label: "Sexta-Feira" },
    { id: "sabado", label: "Sábado" },
    { id: "domingo", label: "Domingo" },
  ];

  const handleChange = (diaId) => {
    if (diasSelecionados.includes(diaId)) {
      onChange(diasSelecionados.filter((dia) => dia !== diaId));
    } else {
      onChange([...diasSelecionados, diaId]);
    }
  };

  return (
    <div className="dias-semana-container">
      {dias.map((dia) => (
        <label key={dia.id} className="dia-checkbox">
          <input
            type="checkbox"
            checked={diasSelecionados.includes(dia.id)}
            onChange={() => handleChange(dia.id)}
          />
          {dia.label}
        </label>
      ))}
    </div>
  );
};

const RotinasFuncionario = () => {
  const {
    rotinas,
    setRotinas,
    loadingRotinas,
    buscarRotinasPorPeriodo,
    salvarRotina,
    atualizarAtividadeRotina,
    today,
  } = useRotinas();
  const { userDecoded } = useUser();
  const location = useLocation();

  const _decoded = userDecoded();
  const _isDev = _decoded?.perfis?.includes("DESENVOLVEDOR");
  const _defaultResponsavel = !_isDev && _decoded?.userId ? _decoded.userId : "";

  const [selectedMonth, setSelectedMonth] = useState(today.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(today.getFullYear());
  const [selectedRotina, setSelectedRotina] = useState(null);
  const [showNovaRotina, setShowNovaRotina] = useState(false);
  const [responsavelSelecionadoPesquisa, setResponsavelSelecionadoPesquisa] =
    useState(_defaultResponsavel);
  const { setIsLoading } = useLoading();
  const [responsavelSelecionadoCadastro, setResponsavelSelecionadoCadastro] =
    useState(_defaultResponsavel);
  const { id } = useParams();
  const [novaRotina, setNovaRotina] = useState({
    data: new Date().toISOString().split("T")[0],
    descricao: "",
    tipo: "LIMPEZA",
    litros: "",
    diasSemana: [],
    atividades: [],
  });
  const [selectedAtividade, setSelectedAtividade] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const loadOptions = useCallback(
    async (inputValue, callback) => {
      if (inputValue.length < 3) {
        callback([]);
        return;
      }
      setIsLoading(true);
      try {
        const user = sessionStorage.getItem("user");
        const { access_token } = JSON.parse(user);
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/v1/rotinas/etiquetas?restauranteId=${id}&tipo=${novaRotina.tipo}&nomeEtiqueta=${inputValue}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authentication: access_token,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          const options = data.map((item) => ({
            value: item,
            label: item,
          }));
          callback(options);
        } else {
          throw new Error(`Erro ${response.status}: ${response.statusText}`);
        }
      } catch (error) {
        console.error("Erro ao buscar etiquetas:", error);
        callback([]);
      } finally {
        setIsLoading(false);
      }
    },
    [id, novaRotina.tipo]
  );

  const handleCreateOption = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setSelectedAtividade(newOption);
    setInputValue("");
  };

  useEffect(() => {
    const initialLoad = async () => {
      const idResponsavelParaBusca =
        location.state?.responsavelSelecionado || responsavelSelecionadoPesquisa;

      if (location.state?.responsavelSelecionado) {
        setResponsavelSelecionadoPesquisa(location.state.responsavelSelecionado);
      }

      const toastId = toast.loading("Buscando rotinas...");
      setIsLoading(true);
      try {
        const dados = await buscarRotinasPorPeriodo({
          mes: selectedMonth,
          ano: selectedYear,
          idResponsavel: idResponsavelParaBusca,
          idRestaurante: id,
        });
        setRotinas(dados);
        toast.update(toastId, {
          render: "Busca concluída!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
      } catch (error) {
        toast.update(toastId, {
          render: "Erro ao carregar rotinas.",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } finally {
        setIsLoading(false);
      }
    };

    initialLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getStatusGeral = (atividades) => {
    if (atividades.length === 0) return "PENDENTE";
    if (atividades.every((a) => a.finalizada)) return "CONCLUIDO";
    if (atividades.some((a) => a.finalizada)) return "EM ANDAMENTO";
    return "PENDENTE";
  };

  const reloadRotinas = async () => {
    const toastId = toast.loading("Buscando rotinas...");
    setIsLoading(true);
    try {
      const dados = await buscarRotinasPorPeriodo({
        mes: selectedMonth,
        ano: selectedYear,
        idResponsavel: responsavelSelecionadoPesquisa,
        idRestaurante: id,
      });
      setRotinas(dados);
      toast.update(toastId, {
        render: "Busca concluída!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "Erro ao carregar rotinas.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const closeDetalheRotina = async () => {
    setSelectedRotina(null);
    reloadRotinas();
  };

  const formatarData = (dataString) => {
    return new Date(dataString).toLocaleDateString("pt-BR");
  };

  const handleAddAtividade = () => {
    if (selectedAtividade) {
      setNovaRotina({
        ...novaRotina,
        atividades: [
          ...novaRotina.atividades,
          {
            nome: selectedAtividade.value,
            finalizada: false,
          },
        ],
      });
      setSelectedAtividade(null);
    }
  };

  const handleSubmitNovaRotina = async (e) => {
    e.preventDefault();
    const toastId = toast.loading("Salvando rotina...");
    setIsLoading(true);

    try {
      if (!id) {
        throw new Error("Nenhum restaurante selecionado");
      }

      if (novaRotina.atividades.length === 0) {
        toast.update(toastId, {
          render: "Adicione pelo menos uma atividade!",
          type: "warning",
          isLoading: false,
          autoClose: 3000,
        });
        setIsLoading(false);
        return;
      }

      if (!responsavelSelecionadoCadastro) {
        toast.update(toastId, {
          render: "Selecione um responsável!",
          type: "warning",
          isLoading: false,
          autoClose: 3000,
        });
        setIsLoading(false);
        return;
      }

      const rotinaParaSalvar = {
        ...novaRotina,
        atividades: novaRotina.atividades.map((atividade) => ({
          nome: atividade.nome,
          finalizada: atividade.finalizada,
        })),
      };

      const sucesso = await salvarRotina(
        rotinaParaSalvar,
        id,
        responsavelSelecionadoCadastro
      );

      if (sucesso) {
        toast.update(toastId, {
          render: "Rotina criada com sucesso!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
        setNovaRotina({
          data: new Date().toISOString().split("T")[0],
          descricao: "",
          tipo: "LIMPEZA",
          litros: "",
          diasSemana: [],
          atividades: [],
        });

        setShowNovaRotina(false);

        setResponsavelSelecionadoPesquisa(responsavelSelecionadoCadastro);
        const rotinasAtualizadas = await buscarRotinasPorPeriodo({
          mes: selectedMonth,
          ano: selectedYear,
          idResponsavel: responsavelSelecionadoCadastro,
          idRestaurante: id,
        });
        setRotinas(rotinasAtualizadas);
      } else {
        toast.update(toastId, {
          render: "Erro ao criar rotina",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Erro ao salvar nova rotina:", error);
      toast.update(toastId, {
        render: `Erro: ${error.message}`,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveAtividade = (index) => {
    const novasAtividades = [...novaRotina.atividades];
    novasAtividades.splice(index, 1);
    setNovaRotina({
      ...novaRotina,
      atividades: novasAtividades,
    });
  };

  const renderDiasSelecionados = (dias) => {
    return dias.map((dia) => (
      <span key={dia} className="dia-tag">
        {dia.substring(0, 3)}
      </span>
    ));
  };

  return (
    <div className="rotinas-container">
      <BackButton inline />
      <h1>Rotinas do Funcionário</h1>
        
      <div className="filtro-container">
        <div className="periodo-selecionado">
          <span>Período:</span>
        </div>
        <div className="filtro-data">
          <FaCalendarAlt className="filtro-icon" />
          <DatePicker
            selected={new Date(selectedYear, selectedMonth - 1, 1)}
            onChange={(date) => {
              setSelectedMonth(date.getMonth() + 1);
              setSelectedYear(date.getFullYear());
            }}
            locale={ptBR}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            className="date-picker-input"
            placeholderText="Selecione mês/ano"
          />
        </div>

        <div>
          <SelectBoxResponsavelPesquisa
            value={responsavelSelecionadoPesquisa}
            onChange={setResponsavelSelecionadoPesquisa}
          />
        </div>
        <div className="botoes-superiores">
          <button
            className="btn-adicionar"
            onClick={reloadRotinas}
            disabled={false}
          >
            Buscar
          </button>
        </div>
      </div>

      <div className="botoes-superiores">
        <button
          className="btn-novo"
          onClick={() => setShowNovaRotina(!showNovaRotina)}
          disabled={false}
        >
          {showNovaRotina ? "Cancelar" : "Nova Rotina"}
        </button>
      </div>

      {showNovaRotina && (
        <form className="form-nova-rotina" onSubmit={handleSubmitNovaRotina}>
          <h3>Criar Nova Rotina</h3>
          <div className="form-group">
            <label>
              Data:
              <input
                type="date"
                name="data"
                value={novaRotina.data}
                onChange={(e) =>
                  setNovaRotina({ ...novaRotina, data: e.target.value })
                }
                required
              />
            </label>
            <label>
              Descrição:
              <input
                type="text"
                name="descricao"
                value={novaRotina.descricao}
                onChange={(e) =>
                  setNovaRotina({ ...novaRotina, descricao: e.target.value })
                }
                placeholder="Descreva a rotina"
                required
              />
            </label>
          </div>

          <div className="form-group">
            <label>
              Tipo:
              <select
                name="tipo"
                value={novaRotina.tipo}
                onChange={(e) =>
                  setNovaRotina({ ...novaRotina, tipo: e.target.value })
                }
                required
              >
                <option value="LIMPEZA">Limpeza</option>
                <option value="ORGANIZAÇÃO">Organização</option>
                <option value="PREPARAÇÃO">Preparação</option>
                <option value="COMPRA">Compra</option>
              </select>
            </label>
            <div>
              <SelectBoxResponsavelCadastro
                value={responsavelSelecionadoCadastro}
                onChange={setResponsavelSelecionadoCadastro}
                required
              />
            </div>
            <label>
              Litros (opcional):
              <input
                type="number"
                step="0.01"
                name="litros"
                value={novaRotina.litros}
                onChange={(e) =>
                  setNovaRotina({ ...novaRotina, litros: e.target.value })
                }
                placeholder="0.00"
              />
            </label>
          </div>

          <div className="dias-rotina-container">
            <label>Dias da Semana:</label>
            <DiasSemanaCheckbox
              diasSelecionados={novaRotina.diasSemana}
              onChange={(novosDias) =>
                setNovaRotina({ ...novaRotina, diasSemana: novosDias })
              }
            />
            <div className="dias-selecionados">
              {renderDiasSelecionados(novaRotina.diasSemana)}
            </div>
          </div>

          <div className="atividades-container">
            <h4>Atividades</h4>
            <div className="add-atividade">
              <div className="input-atividade-container">
                <AsyncCreatableSelect
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions
                  value={selectedAtividade}
                  inputValue={inputValue}
                  onInputChange={setInputValue}
                  onChange={(option) => {
                    setSelectedAtividade(option);
                    setInputValue("");
                  }}
                  onCreateOption={handleCreateOption}
                  formatCreateLabel={(inputValue) =>
                    `Criar nova atividade: "${inputValue}"`
                  }
                  placeholder="Digite para buscar ou criar uma atividade"
                  loadingMessage={() => "Carregando..."}
                  noOptionsMessage={({ inputValue }) =>
                    inputValue.length < 3
                      ? "Digite pelo menos 3 caracteres"
                      : "Nenhuma opção encontrada"
                  }
                />
              </div>
              <button
                type="button"
                onClick={handleAddAtividade}
                className="btn-add"
                disabled={false || !selectedAtividade}
              >
                Adicionar
              </button>
            </div>

            <ul className="lista-atividades">
              {novaRotina.atividades.map((atividade, index) => (
                <li key={`${atividade.nome}-${index}`}>
                  <div className="atividade-info">
                    <span>{atividade.nome}</span>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleRemoveAtividade(index)}
                    className="btn-remove"
                    disabled={false}
                  >
                    ×
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <button
            type="submit"
            className="btn-salvar"
            disabled={false}
          >
            <FaSave /> {false ? "Salvando..." : "Salvar Rotina"}
          </button>
        </form>
      )}

      {false && !showNovaRotina ? (
        <div className="loading-spinner">Carregando...</div>
      ) : (
        <div className="rotinas-grid">
          {rotinas && rotinas.length > 0 ? (
            rotinas.map((rotina) => {
              const statusGeral = getStatusGeral(rotina.atividades);
              return (
                <div
                  key={rotina.id}
                  className={`rotina-card ${statusGeral
                    .toLowerCase()
                    .replace(" ", "-")}`}
                  onClick={() => !false && setSelectedRotina(rotina)}
                >
                  <div className="rotina-data">{formatarData(rotina.data)}</div>
                  <h3 className="rotina-titulo">{rotina.descricao}</h3>
                  <div className="rotina-info">
                    <span className="rotina-tipo">{rotina.tipo}</span>
                    {rotina.diasSemana && rotina.diasSemana.length > 0 && (
                      <div className="rotina-dias-semana">
                        {renderDiasSelecionados(rotina.diasSemana)}
                      </div>
                    )}
                  </div>
                  <span
                    className={`status-badge ${statusGeral
                      .toLowerCase()
                      .replace(" ", "-")}`}
                  >
                    {statusGeral}
                  </span>
                </div>
              );
            })
          ) : (
            <p className="sem-rotinas">
              Nenhuma rotina encontrada para este mês
            </p>
          )}
        </div>
      )}

      {selectedRotina && (
        <ChecklistRotina
          rotina={selectedRotina}
          onClose={closeDetalheRotina}
          onSubmit={async (checklist) => {
            setIsLoading(true);
            try {
              await Promise.all(
                checklist.map((atv) =>
                  atualizarAtividadeRotina(selectedRotina.id, atv.id, atv)
                )
              );
              toast.success("Atividades atualizadas!");
              closeDetalheRotina();
            } catch (error) {
              toast.error(`Erro: ${error.message}`);
            } finally {
              setIsLoading(false);
            }
          }}
        />
      )}

      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default RotinasFuncionario;
